import React from 'react';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { ChatMessage, Conversation } from '@nxsys/store/slices/message/types';
import { getMessageSenderName } from '../helpers/conversation-display';
import MessageTicks from './MessageTicks';

dayjs.extend(relativeTime);

type ChatBubbleProps = {
  message: ChatMessage;
  isMe: boolean;
  maxOtherReadAt: string | null;
  conversation: Conversation;
  currentUser: any;
  isBureau: boolean;
};

const formatMessageTime = (dateStr: string): string => {
  return dayjs(dateStr).format('HH:mm');
};

const formatRelativeTime = (dateStr: string): string => {
  const diff = dayjs().diff(dayjs(dateStr), 'minute');
  if (diff < 1) return 'just now';
  return dayjs(dateStr).fromNow();
};

const ChatBubble: React.FC<ChatBubbleProps> = ({
  message,
  isMe,
  maxOtherReadAt,
  conversation,
  currentUser,
  isBureau,
}) => (
  <div
    className={`chat-bubble-wrapper ${
      isMe ? 'chat-bubble-wrapper-right' : 'chat-bubble-wrapper-left'
    }`}
  >
    {/* Info line */}
    <div className="chat-bubble-info">
      {!isMe && (
        <span className="chat-bubble-sender">
          {getMessageSenderName(
            message.senderUserId,
            conversation,
            currentUser,
            isBureau,
            message.sender,
          )}
        </span>
      )}
      <span>{dayjs(message.createdAt).format('DD/MM/YYYY')}</span>
      <span className="chat-bubble-separator">|</span>
      <span>{formatRelativeTime(message.createdAt)}</span>
    </div>

    {/* Bubble */}
    <div
      className={`chat-bubble ${
        isMe ? 'chat-bubble-right' : 'chat-bubble-left'
      }`}
    >
      {message.content}
      {isMe && (
        <div className="chat-bubble-footer">
          <span className="chat-bubble-time-inline">
            {formatMessageTime(message.createdAt)}
          </span>
          <MessageTicks message={message} maxOtherReadAt={maxOtherReadAt} />
        </div>
      )}
    </div>
  </div>
);

export default ChatBubble;
